import * as actions from "./actionsTypes";

const initialData = {
  loading: false,
  loadingById: false,
  objectiveHistoriesLength: 0,
  objectiveHistories: [],
  objectiveHistory: {},
  objectiveHistoryError: "",
};

export default function ObjectiveHistoryReducer(state = initialData,action) {
  switch (action.type) {
    case actions.LOADING_OBJECTIVE_HISTORY:
      return { ...state, loading: action.payload };
    case actions.LOADING_OBJECTIVE_HISTORY_BY_ID:
      return { ...state, loadingById: action.payload };

    case actions.GET_OBJECTIVE_HISTORY:
      return {
        ...state,
        objectiveHistories: action.payload.objectiveHistories,
        objectiveHistoriesLength: action.payload.objectiveHistoriesLength,
      };
    case actions.GET_OBJECTIVE_HISTORY_BY_ID:
      return {
        ...state, objectiveHistory: action.payload
      };

    case actions.OBJECTIVE_HISTORY_FAIL:
      return { ...state, objectiveHistoryError: action.payload };
    default:
      return state;
  }
}
